import _toConsumableArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useReducer, useMemo, useRef, useEffect } from 'react';
import usePromisifiedDispatch from './usePromisifiedDispatch';
export var unsetDispatch = function unsetDispatch() {
  throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
};
/** Similar to useReducer(), but with redux-like middleware
 *
 * Supports async operations in concurrent mode by returning a promise on dispatch
 * Promise resolves when results are committed
 */

export default function useEnhancedReducer(reducer, startingState, middlewares) {
  var stateRef = useRef(startingState);

  var _useReducer = useReducer(reducer, startingState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      realDispatch = _useReducer2[1];

  useEffect(function () {
    stateRef.current = state;
  }, [state]);
  var dispatchWithPromise = usePromisifiedDispatch(realDispatch, state);
  var outerDispatch = useMemo(function () {
    var _dispatch = unsetDispatch; // closure here around dispatch allows us to change it after middleware is constructed

    var middlewareAPI = {
      getState: function getState() {
        return stateRef.current;
      },
      dispatch: function dispatch(action) {
        return _dispatch(action);
      }
    };
    var chain = middlewares.map(function (middleware) {
      return middleware(middlewareAPI);
    });
    _dispatch = compose(chain)(dispatchWithPromise);
    return _dispatch; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchWithPromise].concat(_toConsumableArray(middlewares)));
  return [state, outerDispatch];
}

var compose = function compose(fns) {
  return function (initial) {
    return fns.reduceRight(function (v, f) {
      return f(v);
    }, initial);
  };
};